import React, {forwardRef} from 'react'

// @ts-ignore
import NavigationMenuItemTaskMore from "./task-more-menu"
import TaskIcon from "../../../../core/gd-components/icons/task-icon/task-icon"
import {ReorderItemProps} from "../../../../core/gd-ui/sortable-list-4/@types";
import {PinTask} from "../../../../core/model2/pin/@types";

type Props = {
    task        : PinTask
} & ReorderItemProps

const NavigationMenuItemTask = forwardRef((props:Props, ref: any) => {

    const onClick = () => {
        gd.taskView.open(props.task.id)
    }

    const classes = Classes('item', 'taskId-'+props.task.id /*required for scroll to node*/, {
        'dnd-preview'   : props.dndPreview,
        'dnd-is-dragged': props.dndIsDragged,
    })

    // style is required for ReorderList (pointer-events: none)
    return (
        <div ref={ref} className={classes} style={props.style} onClick={onClick}>
            <div className="row">
                <TaskIcon className="icon" taskTypeId={props.task.taskTypeId}/>
                <div className="name">{props.task.title}</div>
                <NavigationMenuItemTaskMore task={props.task}/>
            </div>
        </div>
    )
})

export default NavigationMenuItemTask